import { useContext, useEffect, useState } from "react"
import { NotificationContext } from "shared/NotificationContext"
import { Lead, NotificationType, PublicLead } from "shared/topchef.types"
import backofficeApi from 'shared/topchef-api-backoffice';
import Loading from "pages/shared/loading/Loading"

import MoreDetailsCellRenderer from "pages/shared/more-details-renderer/MoreDetailsCellRenderer"
import BackofficeBriefsMarketMenu from "../backoffice-briefs-market-menu/BackofficeBriefsMarketMenu"
import { useErrorBoundary } from "react-error-boundary"
import BriefsList from "pages/shared/briefs-list/BriefsList"


const AllLeads = () => {

  const [leadsLoaded, setLeadsLoaded] = useState<boolean>(false);
  const [allLeads, setAllLeads] = useState<PublicLead[]>([]);
  
  const notificationContext = useContext(NotificationContext);
  const { triggerNotification } = notificationContext;

  const { showBoundary } = useErrorBoundary();

  useEffect(() => {

    async function loadLeadsToValidate() {
      try {
        const leads: Lead[] = await backofficeApi.loadAllLeads();
        setAllLeads(leads);
        setLeadsLoaded(true);
      } catch (error: any) { 
        const newError = new Error(`Problème pour récupérer tous les briefs : '${error.message}'`);
        triggerNotification({type: NotificationType.error, message : newError.message});
        showBoundary(newError);
      } 
    }

    if (leadsLoaded) {
      return;
    }
    loadLeadsToValidate();

  }, [leadsLoaded, allLeads, triggerNotification, showBoundary]);


  const moreDetailsRenderer = (params: any) => {
    const leadId: string = params.data.id;
    return (
      <MoreDetailsCellRenderer url={`/backoffice/leads/all/${leadId}`} label={'Détails'}  />
    );
  };

  if (!leadsLoaded) {
    return (
      <Loading />
    );
  }

  return (
      <div className="container page-briefs-market p-5">

        <h5 className="mb-3">Tous les briefs</h5>
      
        <BackofficeBriefsMarketMenu />

        <BriefsList leads={allLeads} height='80%' paginateResults={true} detailsRenderer={moreDetailsRenderer} />

      </div>
  );

}

export default AllLeads;
